module.exports = __webpack_public_path__ + "img/kapcsolat_background-1920.7f40cff1.png";